'use client';

import React from 'react';
import { VStack, HStack, Text, Box } from '@skin-seoul/design-system';
import { LucideIcon } from '../LucideIcon';
import type { LucideIconName } from '../../assets/icons';

interface TrackingEvent {
  id: string;
  type: string;
  title: string;
  timestamp: string;
  status: 'completed' | 'current' | 'pending';
}

interface TrackingTimelineProps {
  events: TrackingEvent[];
}

const EVENT_ICONS: Record<string, LucideIconName> = {
  customs_cleared: 'CircleCheck',
  in_customs: 'Circle',
  arrived_destination: 'Globe',
  departed: 'Plane',
  invoice_issued: 'Box',
  out_for_delivery: 'Truck',
  delivered: 'CircleCheck',
};

export const TrackingTimeline = ({ events }: TrackingTimelineProps) => {
  return (
    <VStack gap={4} width="100%" alignItems="flex-start">
      {events.map((event) => {
        const iconName = EVENT_ICONS[event.type] || 'CircleCheck';
        const iconColor = event.status === 'completed' ? 'success.600' : 'neutral.700';

        return (
          <React.Fragment key={event.id}>
            <HStack gap={4} width="100%" alignItems="flex-start">
              <Box width={5} height={5} borderRadius="50%" flexShrink={0} color={iconColor}>
                <LucideIcon name={iconName} width={5} height={5} />
              </Box>

              <VStack gap={1} flex="1" alignItems="flex-start">
                <Text textStyle="label.small" fontWeight="medium" color="neutral.700">
                  {event.title}
                </Text>
                <Text textStyle="label.small" fontWeight="regular" color="neutral.400">
                  {event.timestamp}
                </Text>
              </VStack>
            </HStack>
          </React.Fragment>
        );
      })}
    </VStack>
  );
};

